import React from "react";
import cmsData from "../jsonData/cms.json";
import * as Wis from "../style/webbutv-details-style";
import { BokaMote } from "../style/bokaMote";
import LM from "../../assets/portraits/LM_portrait.jpg";

interface CmsContent {
  id: string;
  CmsInfoHeader: string;
  text1: string;
  text2: string;
}

const typedCmsData: CmsContent[] = cmsData;

export const CMSInfo: React.FC = () => {
  return (
    <Wis.BuildWebbContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          width: "90%",
          maxWidth: "900px",
          margin: "0 auto",
        }}
      >
        <Wis.BackArrow />
      </div>

      <Wis.BuildWebbIntroHead>Webbutveckling – CMS</Wis.BuildWebbIntroHead>
      <Wis.BuildWebHeader>CMS</Wis.BuildWebHeader>
      <Wis.Underline />
      
      <Wis.TwoContainer>
        {typedCmsData.slice(0, 2).map((content) => (
          <Wis.Section key={content.id}>
            <Wis.BuildWebHeading>{content.CmsInfoHeader}</Wis.BuildWebHeading>
            <Wis.BuildWebParagraph>{content.text1}</Wis.BuildWebParagraph>
            <Wis.BuildWebParagraph>{content.text2}</Wis.BuildWebParagraph>
          </Wis.Section>
        ))}
      </Wis.TwoContainer>

      <Wis.FullWidthContainer>
        <Wis.Section>
          <Wis.BuildWebHeading>
            {typedCmsData[2].CmsInfoHeader}
          </Wis.BuildWebHeading>
          <Wis.BuildWebParagraph>{typedCmsData[2].text1}</Wis.BuildWebParagraph>
          <Wis.BuildWebParagraph>{typedCmsData[2].text2}</Wis.BuildWebParagraph>
        </Wis.Section>
      </Wis.FullWidthContainer>

      <BokaMote 
          name="Lena" 
          img={LM} 
          text="Boka ett möte med {name}." 
          email="hello@andtech.se"
          subject="Bokningsförfrågan: Möte med Lena"
          body="Hej Lena, Jag är intresserad av att veta mer om webbutveckling & CMS och skulle gärna boka ett möte med dig."
      />    
      
      </Wis.BuildWebbContainer>
  );
};
